import { render, staticRenderFns } from "./AppSeverityPanel.vue?vue&type=template&id=31e56670&scoped=true&"
import script from "./AppSeverityPanel.vue?vue&type=script&lang=js&"
export * from "./AppSeverityPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppSeverityPanel.vue?vue&type=style&index=0&id=31e56670&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e56670",
  null
  
)

export default component.exports